/* eslint-disable */
/*
 ** Google 统计分析脚本
 */
export default ({ app: { router, getRouteBaseName } }) => {
  const routeName = getRouteBaseName();
  // 广告页不使用官网的ga上报
  if (!process.client || ['jp', 'crushme', 'ad'].includes[routeName]) return;

  window.dataLayer = window.dataLayer || [];

  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  /*
   ** 每次路由变更时进行pv统计
   */
  router.afterEach((to, from) => {
    /*
     ** 告诉 GA 增加一个 PV
     */

    window.gtag('set', 'page', to.fullPath);
    window.gtag('send', 'pageview');
  });
};
